module.exports = __webpack_public_path__ + "img/nlp-courses-review.b92d76d0.jpg";